import Image from "next/image"
import styles from "@styles/LoadingScreen.module.css"

export default function LoadingScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Image
          alt={"Heather loading gif"}
          src={"/login_gif.webp"}
          width={448}
          height={336}
          className={styles.gif}
          priority={true}
          quality={85}
        />
      </div>
    </div>
  )
}
